<template lang="pug">
.landing-background-wrap
    .landing-background
        //progressive-img(src="../assets/img/landing.jpg" placeholder="../assets/img/landing-mini.jpg")
        progressive-img(:src="landingImg" :placeholder="landingImgMini" alt="Music festival audience")
        p.sparkle  
        - for (i = 1; i <= 100; i++)
            .circle-container
                .circle

    v-container.landing
        .landing-text-wrap
            .landing-text Sell. Protect. Verify.
            .landing-sub-text Cryptographically proven ticket sales for everyone.

</template>

<script>
//import VueProgressiveImage from "vue-progressive-image";
export default {
  name: "Landing",

  data: () => ({
      landingImg: require("../assets/img/landing.jpg"),
      landingImgMini: require("../assets/img/landing-mini.jpg")
  }),
  components: {
    // 'progressive-img': VueProgressiveImage
  }
};
</script>

<style lang="scss" scoped>
$minBgHeight: 0px;

.landing-background-wrap {
  position: relative;
  // background-image: url('../assets/img/landing.jpg');
  background-size: cover;
  overflow: hidden;
  scroll-behavior: smooth;
  background-repeat: no-repeat;
  background-position-x: center;
  min-height: $minBgHeight;

.landing-background {
  position: absolute;
  width: 100vw;
  height: 100vh;
  min-height: $minBgHeight;
}
  background-color: black;

  ::v-deep .progressive-image {
    width: 100vw !important;
    height: 100vh !important;  
    min-height: $minBgHeight;
    max-width: 100vw !important;
  }

  ::v-deep .progressive-image-wrapper {
    width: 100vw;
    height: 100vh;
    min-height: $minBgHeight;
  }

  ::v-deep img {
    object-fit: cover;
    width: 100vw;
    height: 100vh;
    min-height: $minBgHeight;
  }
}

.landing-background:after {
  position: absolute;
  content: '';
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.65) 100%);
}

.landing {
  position: relative;
  width: 100vw;
  height: 100vh;
  min-height: $minBgHeight;
}

.landing-text-wrap {
  position: absolute;
  color: white;
  bottom: 0;
  z-index: 3;
  padding-bottom: 6em;
}

.landing-text {
  font-size: 6.5em;
  margin-bottom: 1vh;
}

.landing-sub-text {
  font-size: 2.5em;
}

@media (max-height: 900px) {
  .landing-text-wrap {
    padding-bottom: 3em;
  }

  .landing-text {
    font-size: 5em;
    margin-bottom: 1vh;
  }

  .landing-sub-text {
    font-size: 2em;
  }
}

@media (max-height: 700px) {
  .landing-text-wrap {
    padding-bottom: 2em;
  }

  .landing-text {
    font-size: 4.5em;
    margin-bottom: 1vh;
  }

  .landing-sub-text {
    font-size: 1.5em;
  }
}

.background {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;

  mask-image: radial-gradient(
    white 0%,
    white 30%,
    transparent 80%,
    transparent
  );
}

.circle-container {
  $particleNum: 200;
  $particleColor: hsl(180, 100%, 80%);
  z-index: 2;
  position: absolute;
  transform: translateY(-10vh);
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  .circle {
    width: 100%;
    height: 100%;
   
    border-radius: 50%;
    mix-blend-mode: screen;
    background-image: radial-gradient(
      hsl(223, 100%, 80%),
      hsl(223, 100%, 80%) 10%,
      hsla(223, 100%, 80%, 0) 56%
    );

    animation: fadein-frames 200ms infinite, scale-frames 2s infinite;

    @keyframes fade-frames {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 0.7;
      }

      100% {
        opacity: 1;
      }
    }

    @keyframes scale-frames {
      0% {
        transform: scale3d(0.4, 0.4, 1);
      }

      50% {
        transform: scale3d(2.2, 2.2, 1);
      }

      100% {
        transform: scale3d(0.4, 0.4, 1);
      }
    }
  }

  $particleBaseSize: 8;

  
  @for $i from 1 through $particleNum {
    &:nth-child(#{$i}) {
      $circleSize: random($particleBaseSize);
      width: $circleSize + px;
      height: $circleSize + px;

      $startPositionY: random(10) + 100;
      $framesName: "move-frames-" + $i;
      $moveDuration: 28000 + random(9000) + ms;

      animation-name: #{$framesName};
      animation-duration: $moveDuration;
      animation-delay: random(37000) + ms;

      @keyframes #{$framesName} {
        from {
          transform: translate3d(
            #{random(100) + vw},
            #{$startPositionY + vh},
            0
          );
        }

        to {
          transform: translate3d(
            #{random(100) + vw},
            #{- $startPositionY - random(30) + vh},
            0
          );
        }
      }

      .circle {
        animation-delay: random(4000) + ms;
      }
    }
  }
}

.sparkle {
  position: absolute;
  right: 20px;
  bottom: 10px;
  color: white;
  font-family: "Josefin Slab", serif;
  line-height: 27px;
  font-size: 18px;
  text-align: right;
  pointer-events: none;
  animation: sparkle-frames 1.5s ease 5s forwards;
  opacity: 0;
  
  @keyframes sparkle-frames {
    from {
      opacity: 0;
    }
    
    to {
      opacity: 1;
    }
  }
}

</style>
